import { inject } from '@angular/core';

import { UserService } from '@frontend/vanilla/core';

export const cashierGuard = () => {
    const user = inject(UserService);
    return user.isAuthenticated;
};
